import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

function Services({ tenantId }) {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newService, setNewService] = useState({ name: '', description: '', price: '', duration_minutes: 30 });

  const fetchServices = () => {
    setLoading(true);
    apiFetch(`/services?tenant_id=${tenantId}`)
      .then(res => res.json())
      .then(data => {
        setServices(data.services || []);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchServices();
  }, [tenantId]);

  const handleCreate = async (e) => {
    e.preventDefault();
    const sanitizedPrice = typeof newService.price === 'string' 
      ? parseFloat(newService.price.replace(',', '.')) 
      : parseFloat(newService.price);

    if (isNaN(sanitizedPrice)) {
      alert("Por favor, insira um preço válido (ex: 45,00)");
      return;
    }

    const res = await apiFetch(`/services?tenant_id=${tenantId}`, {
      method: 'POST',
      body: JSON.stringify({
        ...newService,
        price: sanitizedPrice,
        duration_minutes: parseInt(newService.duration_minutes || 30)
      })
    });
    if (res.ok) {
      setShowModal(false);
      setNewService({ name: '', description: '', price: '', duration_minutes: 30 });
      fetchServices();
    } else {
      alert("Erro ao criar serviço. Verifique os dados.");
    }
  };

  if (loading) return <div className="stat-label">Carregando catálogo...</div>;

  return (
    <div className="animate-fade">
      <div className="stats-grid" style={{ marginBottom: '2rem' }}>
        <div className="stat-card">
          <div className="stat-header">
            <div className="stat-icon" style={{ background: 'rgba(251, 191, 36, 0.1)', color: '#fbbf24' }}>🛠️</div>
          </div>
          <div className="stat-value">{services.length}</div>
          <div className="stat-label">Serviços Cadastrados</div>
        </div>
      </div>

      <div className="table-wrapper">
        <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--glass-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: '1.5rem' }}>Catálogo de Serviços</h3>
            <p className="stat-label">Lista de serviços prestados e precificação</p>
          </div>
          <button 
            className="btn-primary" 
            style={{ padding: '0.5rem 1rem', fontSize: '0.8rem' }}
            onClick={() => setShowModal(true)}
          >
            + Novo Serviço
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome do Serviço</th>
              <th>Descrição</th>
              <th>Preço (R$)</th>
              <th>Duração (min)</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {services.map((svc) => (
              <tr key={svc[0]}>
                <td>{svc[0]}</td>
                <td style={{ fontWeight: '600', color: '#fbbf24' }}>{svc[1]}</td>
                <td style={{ color: '#94a3b8', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{svc[2] || '-'}</td>
                <td>
                  <span style={{ fontWeight: '700', fontSize: '1.1rem' }}>
                    {svc[3] ? `R$ ${parseFloat(svc[3]).toFixed(2)}` : 'R$ 0,00'}
                  </span>
                </td>
                <td style={{ fontWeight: '600' }}>{svc[4] || 30} min</td>
                <td>
                   <button style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#94a3b8', marginRight: '8px' }}>✏️</button>
                   <button style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#ff4444' }}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {services.length === 0 && (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-secondary)' }}>
            Não há serviços registrados. Cadastre um novo para começar.
          </div>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h3>Novo Serviço</h3>
              <p className="stat-label">Configure um novo item no seu portfólio</p>
            </div>
            <form onSubmit={handleCreate}>
              <div className="form-group">
                <label>Nome do Serviço</label>
                <input 
                  type="text" className="input-field" required
                  value={newService.name}
                  onChange={e => setNewService({...newService, name: e.target.value})}
                  placeholder="Ex: Troca de Óleo"
                />
              </div>
              <div className="form-group">
                <label>Descrição</label>
                <textarea 
                  className="input-field" style={{ minHeight: '80px', resize: 'none' }}
                  value={newService.description}
                  onChange={e => setNewService({...newService, description: e.target.value})}
                  placeholder="Detalhes técnicos do serviço..."
                />
              </div>
              <div className="form-group">
                <label>Preço Base (R$)</label>
                <input 
                  type="number" step="0.01" className="input-field" required
                  value={newService.price}
                  onChange={e => setNewService({...newService, price: e.target.value})}
                  placeholder="0.00"
                />
              </div>
              <div className="form-group">
                <label>Duração Estimada (minutos)</label>
                <input 
                  type="number" className="input-field" required
                  value={newService.duration_minutes}
                  onChange={e => setNewService({...newService, duration_minutes: e.target.value})}
                  placeholder="30"
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                <button type="submit" className="btn-primary">Salvar Serviço</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Services;
